import axios from "axios";
import React, { Component,useEffect } from "react";

import { connect } from "react-redux";
import {set_datapage} from '../../redux/actions/DataPageAction'
import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";
import "css/reportes/fichaespecie.css";
import "css/frontend/ficha-especie.scss"


function Flecha(props){
    if (props.ultimo==undefined || !props.ultimo) {
        return (<span className="icon"><i className="mdi mdi-arrow-right"></i></span>)
    }else{
        return ""
    }

}
function Taxonjerarquia(props) {
  
    if (props.item!=undefined && props.item!="") {
        return (
            <>
            <span>{props.item}</span> 
            <Flecha ultimo={props.ultimo}/>
            </>
        );
        
    }else{
        return "";
    }
    
  }

  function Categoria(props){
    if(props.UICN != null && props.CITES != null && props.AMAZONIA == null)
    return (
        <div class="column is-4">
            
            <div className="mt-3"> 
                <div><span className="category-name"> UICN : </span> <span className="category-apendix"> {props.UICN}</span></div>
            </div>
            <div className="mt-3"> 
                <div><span className="category-name"> CITES : </span> <span className="category-apendix"> {props.CITES}</span></div>
            </div>
            <div className="mt-3"> 
                <div><span className="category-name"> Amazonia : </span> </div>
            </div>
            <div className="mt-3 has-text-right is-size-7"> 
                <strong>Fuente : </strong> {props.FUENTE}
            </div>
        </div>
    )
    else
            return (<></>)
    ;
  }
  function NombreComun(props){
     
    if(props.NOMBRE != null)
    return (
        <div className="column is-4">
            <div className="mt-3"> 
                <div><span className="category-name"> Nombre : </span> <span> {props.NOMBRE}</span></div>
            </div>
            <div className="mt-3 has-text-right is-size-7"> 
                <strong>Fuente : </strong> {props.FUENTE}
            </div>
        </div>
    )
    else
            return (<></>)
    ;
  }
  function Distribucion(props){
     
    if(props.DISTRIBUCION != null)
    return (
        <div className="column is-12">
            <div className="mt-3"> 
                <div><span className="category-name"> </span> <span> {props.DISTRIBUCION}</span></div>
            </div>
            <div className="mt-3 has-text-right is-size-7"> 
                <strong>Fuente : </strong> {props.FUENTE}
            </div>
        </div>
    )
    else
            return (<></>)
    ;
  }
  function Importancia(props){
     
    if(props.IMPORTANCIA != null)
    return (
        <div className="column is-4">
            <div className="mt-3"> 
                <div><span className="category-name"> </span> <span> {props.IMPORTANCIA}</span></div>
            </div>
            <div className="mt-3 has-text-right is-size-7"> 
                <strong>Fuente : </strong> {props.FUENTE}
            </div>
        </div>
    )
    else
            return (<></>)
    ;
  }
  function Manejo(props){
     
    if(props.MANEJO != null)
    return (
        <div className="column is-4">
            <div className="mt-3"> 
                <div><span className="category-name"> </span> <span> {props.MANEJO}</span></div>
            </div>
            <div className="mt-3 has-text-right is-size-7"> 
                <strong>Fuente : </strong> {props.FUENTE}
            </div>
        </div>
    )
    else
            return (<></>)
    ;
  }
  function Origen(props){
     
    if(props.ORIGEN != null)
    return (
        <div className="column is-12">
            <div> 
                <div><strong><span className="category-name"> Recurso : </span> <span> {props.ORIGEN}</span></strong></div>
            </div>
            <div> 
                <div><span className="category-name"> Descripción : </span> <span> {props.DESCRIPCION}</span></div>
            </div>
            <div> 
                <div><span className="category-name"> Fuente : </span> <span> {props.FUENTE}</span></div>
            </div>
            <div> 
                <div><span className="category-name"> País : </span> <span> {props.PAIS}</span></div>
            </div>
        </div>
    )
    else
            return (<></>)
    ;
  }

class FrameComponent extends Component{
    constructor (props) {
        super(props)
    }
    render(){
        return(
            <div className="column has-text-centered">
                <iframe width="500" height="300"  src={this.props.url} scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> 
                </iframe>
            </div>
        )
    }
}

class Recursoscites extends Component {
    
    constructor (props) {
        super(props)
        this.props.set_datapage('')
        this.state = {
            ficha: false,
            imports: false,
            recursos: false,
            regpag:process.env.REG_PAG    
          };
        this.search={txt_ncc:"",sel_cites: "", sel_iucn: ""}     
       
    }
    componentDidMount() {
        var url=baseUrl(`cites/reportes/fichaespecie?`)
    
        url+="&i="+this.props.match.params.idespecie
       
        axios.get(url).then(res => {
            console.log(res.data)
            this.initpage(res.data);
        })
    }
    initpage(result){
        var resultados = result;        
        console.info("%c--- get reporte ", "color:yellow;background:green");
        
       
        this.setState({
            ficha: resultados.datos[0],
            imports: resultados.imports,
            recursos: resultados.recursos
        })

        this.setCategory(resultados.datos)
        this.setNombreComun(resultados.datos)
        this.setDistribucion(resultados.datos)
        this.setImportanciaEcologica(resultados.datos)
        this.setManejo(resultados.datos)
        this.setOrigen(resultados.datos)
        this.setVideoEspecies()
        this.setPhotoEspecie()
        //this.cargarregistros(resultados.datos);
       
        
    }

    setCategory(datos){
        let listaCategorias = []
        let dataCategoria = {}
        for (let index = 0; index < datos.length; index++) {
            listaCategorias[index] = <div class="columns">
                 <Categoria UICN={datos[index].pli_txt_uicn} CITES={datos[index].pli_txt_cite } AMAZONIA={datos[index].pli_bit_amazonian} FUENTE = {datos[index].rec_txt_name}  ></Categoria>

                 {/* <Categoria UICN={datos[index+1] ? datos[index+1].pli_txt_uicn : null} CITES={datos[index+1] ? datos[index+1].pli_txt_cite : null } Amazonia={datos[index+1] ? datos[index+1].pli_bit_amazonian : null}  FUENTE = {datos[index+1] ? datos[index+1].rec_txt_name : null} > </Categoria>
                 <Categoria UICN={datos[index+2] ? datos[index+2].pli_txt_uicn : null} CITES={datos[index+2] ? datos[index+2].pli_txt_cite : null } Amazonia={datos[index+2] ? datos[index+2].pli_bit_amazonian : null}  FUENTE = {datos[index+2] ? datos[index+2].rec_txt_name : null} > </Categoria>  */}
            </div>
            if(datos[index].pli_txt_uicn != null)
                 break;
        }

        this.setState({listaCategorias : listaCategorias})
    }
    setNombreComun(datos){
        let listaNombreComun = []
        let dataNombreComun = {}
        for (let index = 0; index < datos.length; index++) {
            listaNombreComun[index] = <div class="columns">
                 <NombreComun NOMBRE={datos[index].pli_txt_commonnames} FUENTE = {datos[index].rec_txt_name}  ></NombreComun>
            </div>
        }

        this.setState({listaNombreComun : listaNombreComun})
    }
    setDistribucion(datos){
        let listaDistribucion = []
        let dataDistribucion = {}
        for (let index = 0; index < datos.length; index++) {
            listaDistribucion[index] = <div class="columns">
                 <Distribucion DISTRIBUCION={datos[index].pli_txt_distribution} FUENTE = {datos[index].rec_txt_name}  ></Distribucion>
            </div>
        }

        this.setState({listaDistribucion : listaDistribucion})
    }
    setImportanciaEcologica(datos){
        let listaImportancia = []
        let dataImportancia = {}
        for (let index = 0; index < datos.length; index++) {
            listaImportancia[index] = <div class="columns">
                 <Importancia IMPORTANCIA={datos[index].pli_txt_ecologicalsignificance} FUENTE = {datos[index].rec_txt_name}  ></Importancia>
            </div>
        }

        this.setState({listaImportancia : listaImportancia})
    }
    setManejo(datos){
        let listaManejo = []
        let dataManejo = {}
        for (let index = 0; index < datos.length; index++) {
            listaManejo[index] = <div class="columns">
                 <Manejo MANEJO={datos[index].pli_txt_managementandconservation} FUENTE = {datos[index].rec_txt_name}  ></Manejo>
            </div>
        }

        this.setState({listaManejo : listaManejo})
    }
    setOrigen(datos){
        let listaOrigen = []
        let dataManejo = {}
        for (let index = 0; index < datos.length; index++) {
            listaOrigen[index] = <div class="columns">
                 <Origen 
                 ORIGEN={datos[index].rec_txt_name} 
                 DESCRIPCION = {datos[index].rec_txt_description}
                 FUENTE = {datos[index].rec_txt_source}
                 PAIS = {datos[index].pai_txt_name}  >

                 </Origen>
            </div>
        }

        this.setState({listaOrigen : listaOrigen})
    }
    
   
    ir_detalle = (e) => {
        const { recurso } = e.target.dataset;
        var url="/reportes/listaespecies?q4="+recurso
        this.props.history.push(localUrl(url)) 
        
    }

    setPhotoEspecie(){
        let photoArrayUrl ={
            "Harpia harpyja" : baseUrl("imagen/cites/")+this.state.ficha.pli_txt_scientificname+".jpg",
            "Panthera onca" : baseUrl("imagen/cites/")+this.state.ficha.pli_txt_scientificname+".jpg",
            "Leopardus pardalis" : baseUrl("imagen/cites/")+this.state.ficha.pli_txt_scientificname+".jpg",
            "Leopardus wiedii" : baseUrl("imagen/cites/")+this.state.ficha.pli_txt_scientificname+".jpg"
           
        }
        let nameespecie = this.state.ficha.pli_txt_scientificname;
        let nameespecie2 = nameespecie.trim();

        let namefile = nameespecie2.replace(/ /g, "_");
        let filemin = namefile.toLowerCase();
        //this.setState({urlEspecie : photoArrayUrl[this.state.ficha.pli_txt_scientificname]})
        this.setState({urlEspecie : baseUrl("biodiversidad/plineancore/img/")+filemin+".jpg"})
        
    }

    setVideoEspecies(){
        let seccionVideos = []

        let urlEspecies = {
            'Panthera onca' : [
                baseUrl("imagen/cites/video/pantera1.mp4"),
                baseUrl("imagen/cites/video/pantera2.mp4")
            ],

            'Leopardus pardalis' : [
                baseUrl("imagen/cites/video/pardalis1.mp4"),
                baseUrl("imagen/cites/video/pardalis2.mp4")
            ]

            ,
            'Leopardus wiedii' : [
                baseUrl("imagen/cites/video/wiedii1.mp4"),
                baseUrl("imagen/cites/video/wiedii2.mp4")
            ],

            'Harpia harpyja': [
                baseUrl("imagen/cites/video/harpia1.mp4"),
                baseUrl("imagen/cites/video/harpia2.mp4")
            ]       
        }

        let urls =  urlEspecies[this.state.ficha.pli_txt_scientificname]
        if(urls!=undefined){
            for (let index = 0; index < Math.ceil(urls.length/2); index++) {

                seccionVideos[index] =
    
                <div className = "columns">
    
                {typeof urls[index*2] !== 'undefined' ? <FrameComponent url={urls[index*2]}></FrameComponent>  : "" }
                {typeof urls[index*2] !== 'undefined' ? <FrameComponent url={urls[index*2+1]}></FrameComponent> : "" }
    
                </div>
            }
        }
        
        this.setState({seccionVideos : seccionVideos})
    }
    


   

    render() {
        return (
            <>
             <div className="columns is-justify-content-center my-3">
                <h1 className="title is-2"> Información de Especie </h1>
                </div>

            <div className="container">
                
                <div class="columns mt-2">
                   
                    <div class="column">
                        <div className="columns is-justify-content-left">
                            <div className="column">
                                <div className="">
                                     <div className="field">
                                        <label className="label">Nombres Científico: {this.state.ficha.pli_txt_scientificname}</label> 
                                    </div>  
                                    <div className="field">
                                        <label className="label subtitle-ficha-especie"> <span className="ml-2">Categoría </span> </label>
                                            {this.state.listaCategorias}
                                    </div> 

                                      <div className="justificado">
                                <div className="field">
                                <label className="label subtitle-ficha-especie"> <span className="ml-2"> Nombres Comunes </span> </label>
                                <div className="control is-clearfix">
                                    <label>{this.state.listaNombreComun}</label>
                                </div>
                                </div>                                
                                <div className="field">
                                <label className="label subtitle-ficha-especie"> <span className="ml-2"> Taxonomía </span> </label>
                                <p className="taxon-jerarquia">
                                       <div> <span class="title-taxonomia"> <strong>Reino:</strong> </span> {this.state.ficha.pli_txt_kingdom}</div>
                                       <hr class="hr-ficha"></hr>
                                       <div> <span class="title-taxonomia"> <strong>Phylum:</strong></span> {this.state.ficha.pli_txt_phylum}</div>
                                       <hr class="hr-ficha"></hr>
                                       <div> <span class="title-taxonomia" ><strong>Clase:</strong></span>  {this.state.ficha.pli_txt_class}</div>
                                       <hr class="hr-ficha"></hr>
                                       <div> <span class="title-taxonomia"><strong>Orden:</strong></span> {this.state.ficha.pli_txt_order}</div>
                                       <hr class="hr-ficha"></hr>
                                       <div> <span class="title-taxonomia"><strong>Familia:</strong></span> {this.state.ficha.pli_txt_family}</div>
                                       <hr class="hr-ficha"></hr>
                                       <div> <span class="title-taxonomia"><strong>Genus:</strong></span> {this.state.ficha.pli_txt_genus} </div>
                                       <hr class="hr-ficha"></hr>
                                       
                                    </p>
                                </div>   
                                <div className="field">
                                <label className="label subtitle-ficha-especie"> <span className="ml-2"> Distribución </span> </label>
                                <div className="control">
                                    <label>{this.state.listaDistribucion}</label>
                                </div>
                                </div>                                
                            
                                <div className="field">
                                <label className="label subtitle-ficha-especie"> <span className="ml-2"> Importancia Ecológica </span> </label>
                                <div className="control is-clearfix">
                                    <label>{this.state.listaImportancia}</label>
                                </div>
                                </div>                                
                            
                                <div className="field">
                                <label className="label subtitle-ficha-especie"> <span className="ml-2"> Manejo y consevación </span> </label>
                                <div className="control is-clearfix">
                                    <label>{this.state.listaManejo}</label>
                                </div>
                                </div>                     
                                <div className="field">
                                <label className="label subtitle-ficha-especie"> <span className="ml-2"> Colecciones biológicas </span> </label>
                                <div className="control is-clearfix">
                                <a href={localUrl('/reportes/recursosdarwin?e=')+this.state.ficha.pli_txt_scientificname}>Ver en colecciones Biologicas</a>
                                </div>
                                </div> 
                                <div className="field">
                                <label className="label subtitle-ficha-especie"> <span className="ml-2"> Tráfico Ilegal </span> </label>
                                <div className="control is-clearfix">
                                <a href={localUrl('/reportes/listadecomisos?&q1=')+this.state.ficha.pli_txt_scientificname}>Decomisos de la especie</a>
                                </div>
                                </div> 
                                <div className="field">
                                <label className="label subtitle-ficha-especie"> <span className="ml-2"> Informaciones de Exportación e Importación </span> </label>
                                <div className="control is-clearfix">
                                <a href={localUrl('/reportes/listaexportaciones/')+this.state.ficha.pli_int_id}>Exportaciones de la especie en Países Miembros de la OTCA</a>
                                <br></br>
                                <a href={localUrl('/reportes/listaimportaciones/')+this.state.ficha.pli_int_id}>Importaciones de la especie en Países Miembros de la OTCA</a>
                                </div>
                                </div> 
                                </div>
                            </div>       
                        </div>
                    </div>
                    <div class="column">
                    
                    </div>
                </div>
                
                    
                    <div className="column ">
                        <div className="column has-text-centered">
                           {/* <img src={this.state.urlEspecie} width="300px" height = "500"/> */}
                           <img src={this.state.urlEspecie} width="500px" height = "500"/>
                        </div>
                        <div className="column has-text-left">
                        
                        <div className="tile is-parent">
                            <div className="card tile is-child">
                            <header className="card-header">
                                <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-account default"></i></span>
                                Información Complementaria
                                </p>
                            </header>
                            <div className="card-content justificado">
                                <div className="field">
                                <label className="label">RECURSO DE ORIGEN</label>
                                <div className="control is-clearfix">
                                    {this.state.listaOrigen}
                                    {/* <strong>{this.state.ficha.rec_txt_name}</strong>
                                    <br></br>
                                    <label>{this.state.ficha.rec_txt_description}</label>
                                    <br></br>
                                    <strong>Fuente: </strong><label>{this.state.ficha.rec_txt_source}</label>
                                    <br></br>
                                    <strong>Pais: </strong><label>{this.state.ficha.pai_txt_name}</label> */}
                                </div>
                                </div>                               
                                
                                <hr></hr>
                                                                  
                            </div>
                            </div>
                        </div>
                        </div>
                        
                    </div>
                    

                    
                </div>
                
                
                <div className="columns">
                    <div className="column is-justify-content-centered">
                        <h1 className="title is-2 has-text-centered"> Videos de Cámara Trampa  </h1>
                    </div>
                </div>
                {this.state.seccionVideos}
            </div>
            <div className="column"></div>
            <div className="column"></div>
            <div className="column"></div>
            <div className="column"></div>
             {/* <div>
                <section className="section is-main-section">
                    <div className="card has-table">                  
                        <div className="section profile-heading">
                            <div className="columns is-mobile is-multiline">
                                <div className="column is-2">
                                <span className="header-icon user-profile-image">
                                    <img alt="" src={baseUrl("imagen/")+this.state.ficha.pli_txt_scientificname+".jpg"}></img>
                                </span>
                                </div>
                                <div className="column is-4-tablet is-10-mobile name">
                              
                                <p className="tagline">
                                    <a href={localUrl('/reportes/listaexportaciones/')+this.state.ficha.pli_int_id}>Paises miembros Exportadores</a>
                                    <br></br>
                                    <a href={localUrl('/reportes/listaimportaciones/')+this.state.ficha.pli_int_id}>Paises miembros Importadores</a>
                                </p>
                                </div>
                                {this.state.ficha.pli_txt_cite!=null&&this.state.ficha.pli_txt_cite!=""? (
                                     <div className="column is-2-tablet is-4-mobile has-text-centered">
                                     <p className="stat-val">{this.state.ficha.pli_txt_cite.toUpperCase() }</p>
                                     <p className="stat-key">APPENDICES</p>
                                     </div>
                                ) : ("")}
                                {this.state.ficha.pli_txt_uicncountry!=null&&this.state.ficha.pli_txt_uicncountry!=""? (
                                     <div className="column is-2-tablet is-4-mobile has-text-centered">
                                     <p className="stat-val">{this.state.ficha.pli_txt_uicncountry.toUpperCase() }</p>
                                     <p className="stat-key">UICN Nacional</p>
                                     </div>
                                ) : ("")}
                                {this.state.ficha.pli_txt_uicn!=null&&this.state.ficha.pli_txt_uicn!=""? (
                                     <div className="column is-2-tablet is-4-mobile has-text-centered">
                                     <p className="stat-val">{this.state.ficha.pli_txt_uicn.toUpperCase() }</p>
                                     <p className="stat-key">UICN</p>
                                     </div>
                                ) : ("")}
                               
                               
                            </div>
                        </div>
                    </div>
                    <div className="tile is-ancestor">
                        <div className="tile is-parent">
                            <div className="card tile is-child">
                            <header className="card-header">
                                <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-account-circle default"></i></span>
                                Detalle
                                </p>
                            </header>
                            <div className="card-content">
                                <div className="field">
                                <label className="label">Nombres Comunes</label>
                                <div className="control is-clearfix">
                                    <label>{this.state.ficha.pli_txt_commonnames}</label>
                                </div>
                                </div>                                
                            
                                <div className="field">
                                <label className="label">Distribución</label>
                                <div className="control is-clearfix">
                                    <label>{this.state.ficha.pli_txt_distribution}</label>
                                </div>
                                </div>                                
                            
                                <div className="field">
                                <label className="label">Importancia Ecologia</label>
                                <div className="control is-clearfix">
                                    <label>{this.state.ficha.pli_txt_ecologicalsignificance}</label>
                                </div>
                                </div>                                
                            
                                <div className="field">
                                <label className="label">Manejo y conservacion</label>
                                <div className="control is-clearfix">
                                    <label>{this.state.ficha.pli_txt_managementandconservation}</label>
                                </div>
                                </div>                     

                                
                            </div>
                            </div>
                        </div>
                        <div className="tile is-parent">
                            <div className="card tile is-child">
                            <header className="card-header">
                                <p className="card-header-title">
                                <span className="icon"><i className="mdi mdi-account default"></i></span>
                                Informacion Complementaria
                                </p>
                            </header>
                            <div className="card-content">
                                <div className="field">
                                <label className="label">RECURSO DE ORIGEN</label>
                                <div className="control is-clearfix">
                                    <strong>{this.state.ficha.rec_txt_name}</strong>
                                    <br></br>
                                    <label>{this.state.ficha.rec_txt_description}</label>
                                    <br></br>
                                    <strong>Fuente: </strong><label>{this.state.ficha.rec_txt_source}</label>
                                    <br></br>
                                    <strong>Pais: </strong><label>{this.state.ficha.pai_txt_name}</label>
                                </div>
                                </div>                               
                                
                                <hr></hr>
                                                                  
                            </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div> */}
            </>
           
        )
    }
}

const md = state => {

}
export default connect(null, {set_datapage})(Recursoscites)